import { useTranslation } from '../../i18n/react';

/**
 * Password show/hide eye toggle — extracted from ForgotPasswordScreen (its
 * "Create Password"/"Re-enter Password" fields), now also used by the
 * email-registration flow's Step 1 password field. Same icon/behavior
 * everywhere it appears.
 */
function EyeIcon({ open }: { open: boolean }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      {open ? (
        <>
          <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7Z" stroke="#8A7028" strokeWidth="1.5" />
          <circle cx="12" cy="12" r="3" stroke="#8A7028" strokeWidth="1.5" />
        </>
      ) : (
        <>
          <path d="M3 3l18 18M10.6 10.6a3 3 0 0 0 4.24 4.24M6.4 6.7C4 8.3 2 12 2 12s4 7 10 7c1.7 0 3.2-.4 4.5-1.1M17.8 15.9C20.3 14 22 12 22 12s-4-7-10-7c-.6 0-1.2.05-1.8.15" stroke="#8A7028" strokeWidth="1.5" strokeLinecap="round" />
        </>
      )}
    </svg>
  );
}

/**
 * `field` names WHICH password field this toggle controls, as a key into the
 * auth catalog's a11y group — the accessible name is a full translated
 * sentence ("Show password" / "Ocultar contraseña"), never an English
 * prefix concatenated onto a label.
 */
export function PasswordVisibilityToggle({ visible, onToggle, field }: { visible: boolean; onToggle: () => void; field: 'passwordField' | 'passwordConfirmField' }) {
  const { t } = useTranslation('auth');
  const fieldName = t(`a11y.${field}`);
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={visible ? t('a11y.hide', { field: fieldName }) : t('a11y.show', { field: fieldName })}
      style={{ background: 'none', border: 'none', padding: 4, cursor: 'pointer', display: 'flex', WebkitTapHighlightColor: 'transparent' }}
    >
      <EyeIcon open={visible} />
    </button>
  );
}
